import React from "react";
import * as S from "./InputText.styled";
import { ReactComponent as IconError } from "assets/svgs/rounded-warning.svg";

const InputText = ({
  title,
  value,
  onChange,
  placeholder,
  defaultValue,
  icon,
  hasError,
  errorMessage,
  type,
  maxLength,
  mask,
  maskPlaceholder = "",
  ...props
}) => {
  return (
    <S.InputContainer>
      <S.Title htmlFor={title} hasError={hasError}>
        {title}
      </S.Title>
      <S.MaskedStyledTextField
        label={title}
        onChange={onChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
        icon={icon}
        value={value}
        errormessage={hasError ? errorMessage : ""}
        type={type}
        id={title}
        mask={value ? mask : null}
        maskPlaceholder={maskPlaceholder}
        {...props}
      />
      {hasError && errorMessage && (
        <S.ErrorMessage>
          <IconError />
          {errorMessage}
        </S.ErrorMessage>
      )}
    </S.InputContainer>
  );
};

export default InputText;
